import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  background: theme => ({
    backgroundColor: theme.colors.backgroundColor,
    borderTopRightRadius: 20,
    borderTopLeftRadius: 20,
    overflow: 'hidden',
    paddingTop: 10
  }),
  linearGradientContainer: theme => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: -1,
    backgroundColor: theme.colors.background.primary[0],
    overflow: 'hidden',
  }),
  linearGradient: {
    width: '100%',
    height: '50%',
  },
});
